import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isDeliveryProviderSupported = createSelector(onlineOrderState, (onlineOrder) => {
    const supportedProviders = onlineOrder?.orderType?.SupportedDeliveryProviders;

    return supportedProviders?.length > 0;
});
